// Only the bare web entry is marketing. Hash routes and integration query
// strings keep the existing application, including bookmarked deep links.
const isLandingEntry = ({ pathname, hash, search }) => pathname === '/' && !hash && !search;

module.exports = isLandingEntry;
